
import { useLanguage } from "@/contexts/LanguageContext";
import { useMemo } from "react";
import AnimatedCTAButton from "./AnimatedCTAButton";

export default function HeroSection() {
  const { t } = useLanguage();
  
  // Memoize the title HTML to prevent unnecessary re-calculations
  const titleWithStyledDash = useMemo(() => {
    const titleText = t("hero.title");
    return titleText.split("—").join("<span class='shortened-dash'>—</span>");
  }, [t]);
  
  return (
    <section className="py-4 text-center">
      <div className="container mx-auto px-4">
        <h1 className="mb-3 text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight">
          <span dangerouslySetInnerHTML={{ __html: titleWithStyledDash }}></span>
        </h1>
        <p className="mx-auto mb-6 max-w-2xl text-base text-muted-foreground">
          {t("hero.subtitle")}
        </p>
        <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
          <AnimatedCTAButton 
            to="/find-places" 
            animationDirection="left"
            delay={300}
          >
            {t("cta.findPlaces")}
          </AnimatedCTAButton>
          <AnimatedCTAButton 
            to="/rate-place" 
            variant="outline"
            animationDirection="right"
            delay={500}
          >
            {t("cta.ratePlace")}
          </AnimatedCTAButton>
        </div>
      </div>
    </section>
  );
}
